// extracted by mini-css-extract-plugin
export default {"caption":"VideoPlayer_caption__ZqTFB"};